

   <p-dialog   [(visible)]="showListStands"> 
   <mat-slide-toggle    [(ngModel)]="shwoAssigned" (change)="onShowAll()">Show All !</mat-slide-toggle>

    <div class="table-container mat-elevation-z8">


    <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>
      
<table mat-table #table [dataSource]="dataSource" >
    <ng-container matColumnDef="num">
      <th mat-header-cell *matHeaderCellDef> Stand </th>
      <td mat-cell *matCellDef="let row"> {{row.num}} </td>
    </ng-container>
  
    <ng-container matColumnDef="standType">
        <th mat-header-cell *matHeaderCellDef> Type </th>
        <td mat-cell *matCellDef="let row"> {{row.standType}} </td>
      </ng-container>


      <ng-container matColumnDef="superficie">
          <th mat-header-cell *matHeaderCellDef> Superficie </th>
          <td mat-cell *matCellDef="let row"> {{row.superficie}} </td>
        </ng-container>

        <ng-container matColumnDef="clients">
            <th mat-header-cell *matHeaderCellDef> Clients </th>
            <td mat-cell *matCellDef="let row">  {{row.clientList}}   </td>
          </ng-container>

      <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let row"> 
  <button mat-icon-button (click)="select(row)" ><mat-icon>add_shopping_cart</mat-icon></button>
    </td>
        </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="columnsToShow; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToShow"></tr>
  </table>
</div>
 </p-dialog>